







































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {LongueursVente} from '@/models';

import CrudLongueursVenteEdit from '@/components/Crud/LongueursVente/Edit.vue';

@Component({
	components: {
		CrudLongueursVenteEdit,
	}
})
export default class CrudLongueursVenteEditDialog extends Vue {
	@InOut({ type: LongueursVente  , isVModel: true }) private value!: LongueursVente;

	@Emit()
	private onSubmit(longueursVente: LongueursVente) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
